/**
 * MUI sx style definitions for DomainActionModal and its sub-components.
 */
export const domainActionModalStyles = {
  /** Shared DialogTitle row — flex row with title on left, close icon on right */
  dialogTitleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: 700,
  },

  /** Dashed drop-zone Paper inside the upload dialog */
  uploadDropzone: {
    borderStyle: "dashed",
    borderWidth: 2,
    borderRadius: 3,
    p: 5,
    textAlign: "center",
    cursor: "pointer",
    bgcolor: "#fafafa",
  },

  /** Upload cloud icon */
  uploadIcon: { fontSize: 60, color: "#1976d2" },

  /** Callout box with format instructions */
  uploadInfoBox: {
    display: "flex",
    alignItems: "flex-start",
    gap: 1.5,
    p: 2,
    border: "1px solid #CFE3FF",
    backgroundColor: "#F5FAFF",
    borderRadius: 2,
  },

  /** Info icon inside the callout */
  infoIcon: { color: "#1976d2", fontSize: 18, mt: "2px" },

  /** Inline code label for column name */
  codeLabel: {
    bgcolor: "#EEF4FF",
    border: "1px solid #D6E4FF",
    borderRadius: 1,
    px: 0.5,
    fontSize: 12,
    fontWeight: 600,
  },

  /** "Download Template" text button */
  downloadTemplateBtn: {
    mt: 1,
    p: 0,
    minWidth: 0,
    textTransform: "none",
    color: "#1976d2",
    fontWeight: 600,
    "&:hover": { backgroundColor: "transparent" },
  },

  /** Primary action button (black fill) used in upload / whitelist / blacklist dialogs */
  primaryActionButton: {
    backgroundColor: "#000",
    color: "#fff",
    textTransform: "none",
    "&:hover": { backgroundColor: "#000", color: "#fff", boxShadow: "none" },
  },

  /** Ghost cancel button used in whitelist / blacklist dialogs */
  ghostCancelButton: {
    color: "#616161",
    "&:hover": { backgroundColor: "transparent", color: "#616161" },
  },

  /** Row inside a domain list Paper */
  domainListRow: { px: 2, py: 1.5, borderBottom: "1px solid #eee" },

  /** Read-only "Requested For" paper */
  requestedForPaper: { p: 1.5, mt: 1, bgcolor: "#fafafa" },
};
